import { booleanAttribute, Directive, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { NgControl, Validators } from '@angular/forms';
import { FormErrorsService } from '../../core/services/form-errors.service';

@Directive({
	standalone: true,
})
export class InputBase implements OnInit {
	@Input() id: string = null;

	@Input() name: string = null;

	@Input() label: string = null;

	@Input({ transform: booleanAttribute }) set required(isRequired: boolean) {
		this._required = isRequired;
	}

	get required() {
		const control = this.ngControl?.control;
		return control?.hasValidator(Validators.required) ?? this._required;
	}

	@Input() placeholder: string = null;

	@Input({ transform: booleanAttribute }) set disabled(isDisabled: boolean) {
		this._disabled = isDisabled;
	}

	get disabled() {
		return this._disabled;
	}

	@Input({ transform: booleanAttribute }) error = false;

	@Input({ transform: booleanAttribute }) fullWidth = false;

	@Input({ transform: booleanAttribute }) showMessages = false;

	@Output() inputEvent = new EventEmitter<Event>();

	@Output() focusEvent = new EventEmitter<Event>();

	@Output() blurEvent = new EventEmitter<Event>();

	@Output() keyDownEvent = new EventEmitter<Event>();

	@Output() keyUpEvent = new EventEmitter<Event>();

	@Input() value: any;

	public _disabled = false;

	public _required = false;

	public onChange: (value: any) => void = () => {};

	public onTouched: () => void = () => {};

	// eslint-disable-next-line @typescript-eslint/member-ordering
	private ngControl: NgControl;

	get errorMessages(): string[] {
		if (!this.ngControl) {
			return [];
		}
		const errors = this.formErrorsService.getFieldErrorMessages(this.ngControl, this.label || this.id || this.name || 'Field');
		return errors;
	}

	// eslint-disable-next-line @typescript-eslint/member-ordering
	constructor(
		private injector: Injector,
		private formErrorsService: FormErrorsService,
	) { }

	ngOnInit(): void {
		const ngControl = this.injector.get(NgControl, null);
		if (ngControl) {
			this.ngControl = ngControl;
		}
	}

	writeValue(value: any): void {
		this.value = value;
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	setDisabledState(isDisabled: boolean): void {
		this._disabled = isDisabled;
	}

	onBlur(event: Event) {
		this.onTouched();
		this.blurEvent.emit(event);
	}
}
